import React, { useState, useEffect } from 'react'
import Avtar from '../../Images/no image.png'
import { getFilterAllCategories } from '../../Web Apis/Apis'
import { message } from 'antd'
import Loader from '../Loader/Loader'


function ViewVoucher({ showViewVoucherModal, setShowViewVoucherModal, selectedVoucher }) {

    console.log("daa", selectedVoucher)
    const [filterMainCategory, setFilterMainCategory] = useState([])
    const [loading, setLoading] = useState(false)


    const [open, setOpen] = useState(showViewVoucherModal)

    const closeViewModal = () => {
        setOpen(false)
        setShowViewVoucherModal(false)
    }



     const getAllFilterCategory = async () => {
            try {
                setLoading(true)
    
                const response = await getFilterAllCategories()
    
                if (response?.data?.success) {
                    // const modifiedObject = response?.data?.data?.reduce((acc, item) => {
                    //     acc[item?.id] = item.subcategory; // Assign category id as key and subcategories as value
                    //     return acc;
                    // }, {});
    
                    setFilterMainCategory(response?.data?.data)
                    // setFilterCategories(modifiedObject)
                    // console.log("data data", modifiedObject)
                }
    
            } catch (error) {
                console.log("Error while fetch filtered category", error.message)
                if (error.message === 'Network Error' || error.message.includes('ERR_INTERNET_DISCONNECTED')) {
                    // Handle internet disconnection
                    return;
                }
                // Handle specific error cases
                if (error?.response?.status === 401) {
                    window.alert("Your account is logged in to another device, please login again !")
                    localStorage.clear();
                    window.location.href = "/login"
                }
                if (error?.response?.status === 500) {
                    message.error("Server not responding")
                }
            } finally {
                setLoading(false)
            }
        }

useEffect(() => {
        getAllFilterCategory();

    }, [])


    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white  rounded-lg shadow-lg w-[900px] h-[600px] flex flex-col">
                <h3 className="text-xl font-bold mb-1 text-center bg-gradient-to-br from-blue-950 to-blue-500 py-2 text-white">
                    View Voucher Details
                </h3>
                <form className="p-8 overflow-y-auto">

                    <div className="flex gap-2 ">
                        <div className="w-full mt-2">
                            <label className="block mb-1 font-bold">Title</label>
                            <input
                                type="text"
                                name="title"
                                className="border border-gray-800 p-2 w-full"

                                value={selectedVoucher.title}
                                disabled
                            />
                        </div>

                        <div className="w-full mt-2">
                            <label className="block mb-1 font-bold">
                            {filterMainCategory?.find((cat) => cat.id === 2)?.category}
                                </label>
                            <input
                                type="text"
                                name="title"
                                className="border border-gray-800 p-2 w-full"

                                value={selectedVoucher.occasions}
                                disabled
                            />
                        </div>
                       
                    </div>

                    <div className="flex gap-2 ">
                        <div className="w-full mt-2">
                            <label className="block mb-1 font-bold">
                            {filterMainCategory?.find((cat) => cat.id === 7)?.category}
                            </label>
                            <input
                                type="text"
                                name="title"
                                className="border border-gray-800 p-2 w-full"

                                value={selectedVoucher.ageGroups}
                                disabled
                            />
                        </div>

                        <div className="w-full mt-2">
                            <label className="block mb-1 font-bold">Coins</label>
                            <input
                                type="text"
                                name="title"
                                className="border border-gray-800 p-2 w-full"

                                value={selectedVoucher.coin}
                                disabled
                            />
                        </div>

                        <div className="w-full mt-2">
                            <label className="block mb-1 font-bold">
                            {filterMainCategory?.find((cat) => cat.id === 3)?.category}
                            </label>
                            <input
                                type="text"
                                name="title"
                                className="border border-gray-800 p-2 w-full"

                                value={selectedVoucher.genders}
                                disabled
                            />
                        </div>
                       
                    </div>

                    <div className="flex gap-2 ">
                        <div className="w-full mt-2">
                            <label className="block mb-1 font-bold">
                            {filterMainCategory?.find((cat) => cat.id === 14)?.category}
                            </label>
                            <input
                                type="text"
                                name="title"
                                className="border border-gray-800 p-2 w-full"

                                value={selectedVoucher.emotionalImpacts}
                                disabled
                            />
                        </div>

                        <div className="w-full mt-2">
                            <label className="block mb-1 font-bold">
                            {filterMainCategory?.find((cat) => cat.id === 8)?.category}
                            </label>
                            <input
                                type="text"
                                name="title"
                                className="border border-gray-800 p-2 w-full"

                                value={selectedVoucher.hobbies}
                                disabled
                            />
                        </div>

                        <div className="w-full mt-2">
                            <label className="block mb-1 font-bold">
                            {filterMainCategory?.find((cat) => cat.id === 12)?.category}
                            </label>
                            <input
                                type="text"
                                name="title"
                                className="border border-gray-800 p-2 w-full"

                                value={selectedVoucher.lifeStages}
                                disabled
                            />
                        </div>
                       
                    </div>

                        <div className="flex gap-2 ">
                        <div className="w-full mt-2">
                            <label className="block mb-1 font-bold">
                                {filterMainCategory?.find((cat) => cat.id === 9)?.category}
                            </label>
                            <input
                                type="text"
                                name="title"
                                className="border border-gray-800 p-2 w-full"

                                value={selectedVoucher.personalityTypes}
                                disabled
                            />
                        </div>

                        <div className="w-full mt-2">
                            <label className="block mb-1 font-bold">
                            {filterMainCategory?.find((cat) => cat.id === 4)?.category}
                            </label>
                            <input
                                type="text"
                                name="title"
                                className="border border-gray-800 p-2 w-full"

                                value={selectedVoucher.relationships}
                                disabled
                            />
                        </div>

                        <div className="w-full mt-2">
                            <label className="block mb-1 font-bold">
                            {filterMainCategory?.find((cat) => cat.id === 11)?.category}
                            </label>
                            <input
                                type="text"
                                name="title"
                                className="border border-gray-800 p-2 w-full"

                                value={selectedVoucher.personalization}
                                disabled
                            />
                        </div>
                       
                    </div>

                    <div className="flex gap-2 ">
                        <div className="w-full mt-2">
                            <label className="block mb-1 font-bold">
                            {filterMainCategory?.find((cat) => cat.id === 10)?.category}
                            </label>
                            <input
                                type="text"
                                name="title"
                                className="border border-gray-800 p-2 w-full"

                                value={selectedVoucher.locations}
                                disabled
                            />
                        </div>

                        <div className="w-full mt-2">
                            <label className="block mb-1 font-bold">
                            {filterMainCategory?.find((cat) => cat.id === 15)?.category}
                            </label>
                            <input
                                type="text"
                                name="title"
                                className="border border-gray-800 p-2 w-full"

                                value={selectedVoucher.voucherType}
                                disabled
                            />
                        </div>

                        <div className="w-full mt-2">
                            <label className="block mb-1 font-bold">
                            {filterMainCategory?.find((cat) => cat.id === 13)?.category}
                            </label>
                            <input
                                type="text"
                                name="title"
                                className="border border-gray-800 p-2 w-full"

                                value={selectedVoucher.deliveryTimeFrame}
                                disabled
                            />
                        </div>
                       
                    </div>

                    <div className="w-full mt-2">
                            <label className="block mb-1 font-bold">Description</label>
                            <textarea
                            rows={2}
                                type="text"
                                name="title"
                                className="border border-gray-800 p-2 w-full"

                                value={selectedVoucher.description}
                                disabled
                            />
                        </div>

                        <div className="w-full mt-2">
                            <label className="block mb-1 font-bold">Image Json</label>
                            <textarea
                            rows={8}
                                type="text"
                                name="title"
                                className="border border-gray-800 p-2 w-full"

                                value={JSON.stringify(selectedVoucher.templateJson, null, 2)}
                                disabled
                            />
                        </div>


                    <div className="w-full mt-2">
                            <label className="block mb-1 font-bold">Voucher Image</label>
                            <img
                                src={selectedVoucher?.image || Avtar}
                                alt='Voucher Pic'
                                className='h-32 w-32 object-cover rounded-full'
                            >
                            </img>
                        </div>

                       
                    {loading && <Loader/>}

                </form>

                <div className="flex justify-end gap-6 p-4">
                        <button onClick={closeViewModal} className="bg-gray-300 border border-gray-800 text-black w-52 py-2 px-4 rounded-md hover:bg-gray-400 transition duration-200">
                            Close
                        </button>


                    </div>
            </div>
        </div>
    )
}

export default ViewVoucher